function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/* eslint-disable import/prefer-default-export */
import { attach } from './attach';
import { str, func, dom } from '../../../util';

var getStylePropertyValue = function getStylePropertyValue(decl, property) {
  return decl.getPropertyValue(property);
};

var configRE = /((?:\d?\.)?\d+(?:ms|s))\s([\s\S]+)/;

var parseConfig = function parseConfig(config) {
  var _config$match = config.match(configRE),
      _config$match2 = _slicedToArray(_config$match, 3),
      duration = _config$match2[1],
      easing = _config$match2[2];

  return {
    duration: duration,
    easing: easing
  };
};

var numberifyDuration = function numberifyDuration(duration) {
  if (/ms$/.test(duration)) {
    return parseFloat(duration.slice(0, -2));
  } else if (/s$/.test(duration)) {
    return parseFloat(duration.slice(0, -1)) * 1000;
  } else {
    throw new Error('Numberify duration failed.');
  }
};

export var motion = function motion(config, initial, end, delay) {
  var duration;
  var easing;

  if (typeof config === 'number') {
    duration = config.toString();
  } else {
    var ret = parseConfig(config);
    duration = ret.duration;
    easing = ret.easing || 'ease';
  }

  if (duration == null) {
    throw new Error('transition duration should be specified.');
  }

  return function (el, callback) {
    var orginStyle = el.getAttribute('style');
    var currentStyle = {};
    var computedStyle = window.getComputedStyle(el);
    var transitionRule = [];
    var hiddenRule = '';

    for (var i in initial) {
      if (Object.prototype.hasOwnProperty.call(initial, i) && initial[i] != null) {
        var propertyName = str.hyphenate(i);
        transitionRule.push("".concat(propertyName, " ").concat(duration, " ").concat(easing));
        currentStyle[i] = getStylePropertyValue(computedStyle, propertyName);

        if (i === 'height') {
          hiddenRule = hiddenRule || 'overflow: hidden;';
          el.style['overflow'] = 'hidden';
        }

        if (initial[i] === '*') {
          el.style[i] = currentStyle[i];
        } else {
          el.style[i] = initial[i];
        }
      }
    } // 强制触发重排以保证动画的执行


    dom.forceReflow(el);

    var run = function run(motionToken) {
      el.style.cssText = "\n        ".concat(orginStyle, "; transition: ").concat(transitionRule.join(', '), "; ").concat(hiddenRule, "\n      ");

      for (var _i2 in end) {
        if (end.hasOwnProperty(_i2) && end[_i2] != null) {
          if (end[_i2] === '*') {
            el.style[_i2] = currentStyle[_i2];
          } else {
            el.style[_i2] = end[_i2];
          }
        }
      }

      attach(el, orginStyle, numberifyDuration(duration), motionToken).then(function () {
        return callback();
      })["catch"](function (err) {
        if (!err.canceled) {
          callback();
        }
      });
      return function () {
        if (motionToken && func.isFunction(motionToken.cancel)) {
          motionToken.cancel();
        }
      };
    };

    var token = Object.create(null);

    if (typeof delay === 'number') {
      var handler = null;
      var timeoutId = window.setTimeout(function () {
        handler = run(token);
      }, delay);
      return function () {
        if (!func.isFunction(handler) && timeoutId) {
          window.clearTimeout(timeoutId);
        } else if (func.isFunction(handler)) {
          handler();
        }
      };
    } else {
      return run(token);
    }
  };
};